{
  "name": "@ipreo/demo-card",
  "version": "21.2.3",
  "author": "Polaris Team",
  "license": "UNLICENSED",
  "peerDependencies": {
    "@angular/common": "21.x",
    "@angular/core": "21.x"
  },
  "dependencies": {
    "tslib": "2.x"
  },
  "nmp": {
    "externalDependencies": {},
    "jsBundle": "./bundles-nmp/demo-card.min.js",
    "jsBundleType": "umd",
    "private": false,
    "platforms": {
      "angular": {
        "moduleName": "DemoCardModule",
        "selector": "polaris-demo-card"
      }
    },
    "northstar-card-v1": {
      "moduleName": "DemoCardModule",
      "selector": "polaris-demo-card",
      "supportedModes": [
        "tiled"
      ]
    }
  }
}